module.exports = __webpack_public_path__ + "static/media/logo.a222c116.svg";